/* eslint-disable */
import React from 'react';
import { useTranslation } from 'react-i18next';

//MUI Icons
import { Comment } from '@mui/icons-material';
//Custom Components
import TableButton from './TableButton';

//Types
import { ITableActionButtonDetail } from '@/@types/ui/Table';
import { Badge } from '@mui/material';

interface ITableButtonComments extends ITableActionButtonDetail {
  disabled?: boolean;
  badgeValue?: number;
}

function TableButtonComments(props: ITableButtonComments) {
  const { t } = useTranslation();

  const { disabled, badgeValue = 0 } = props;

  return (
    <Badge color="primary" badgeContent={badgeValue} showZero={false} sx={{mr: "4px"}}>
      <TableButton allow={disabled ? 'none' : 'one'} startIcon={<Comment />} selection={{}} variant="outlined" {...props}>
        {t('buttons.comments')}
      </TableButton>
    </Badge>
  );
}

export default TableButtonComments;
